import { Col, message, PageHeader, Row, Spin, Select, Space, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import { SelectItem, Form, FormItem, cuentaMask, RangePickerItem, TableItem, dineroDisabledMask, ButtonItem, ErrorItem } from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveBar } from "@nivo/bar"; 
import reporteInsumosMasCompradosPdf from "../../../../Pdf/reporteInsumosMasCompradosPdf";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const { Option } = Select;
const { TabPane } = Tabs;

class ReporteInsumosMasComprados extends Component {
  state = {
    loading: false,
    objetoProveedores: null,
    objetoProyectos: null,
    objetoUniadesDeNegocio: null,
    dataReporte: null,
    todasInsumos: [],
    dataGrafico: [],
    piezasCompradas: 0,
    costosTotales: 0,
  };

  atras() { this.props.history.goBack(); }

  async componentDidMount() {
    this.setState({ loading: true });

    await Promise.all([
      axios.post("proveedores/selectProveedores", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProveedores: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.stringBuscar}</Option>
            )),
          });
        }
      }),
      axios.post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>{value.nombre}</Option>
            )),
          });
        }
      }),
      axios.post("unidadesdenegocio/selectUnidadesDeNegocio", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + " - " + value.nombre}
              </Option>
            )),
          });
        }
      })
    ]);

    this.consultarReporteInsumosMasComprados({
      periodo: [moment().subtract(1, "month"), moment()],
      proveedores: 0,
      filtrarProyecto: 0,
      estadoFacturas: 5,
    });
  }

  crearGraficoBarras(insumos) {
    const top10 = [...insumos].slice(0, 10).reverse();
    const dataGrafico = top10.map(item => ({
      insumo: (item.clave || 'Sin Clave') + ` (${item.moneda})`,
      "Costo Total (MXN)": item.costoTotalMxn || 0,
      descCompleta: item.descripcion
    }));
    this.setState({ dataGrafico });
  }

  consultarReporteInsumosMasComprados(values) {
    this.setState({ loading: true });
    axios.post("reportesDeCompras/reporteInsumosMasComprados", 
        { ...values, empresaId: this.props.empresaId }, 
        { headers: this.props.headersToken }
    ).then((res) => {
        if (res.data.success === 2) {
          this.crearGraficoBarras(res.data.insumos);
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInsumos: res.data.insumos,
            piezasCompradas: res.data.totales.cantidad,
            costosTotales: res.data.totales.costos,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      }).catch(() => {
          message.error("Error de conexión");
          this.setState({ loading: false });
      });
  }

  descargarExcel() {
    let datosDescargar = this.state.todasInsumos.map((item) => ({
      "Clave": item.clave,
      "Código Barras": item.codigoBarras,
      "Descripción": item.descripcion,
      "Familia": item.familia || 'N/A',
      "Marca": item.marca || 'N/A',
      "Tipo de Insumo": item.tipoInsumo || 'N/A',
      "Cantidad Comprada": item.cantidad,
      "Moneda": item.moneda,
      "Costo Unit. Promedio": item.precioUnitario,
      "Costo Total": item.costoTotal,
      "Costo Total (MXN)": item.costoTotalMxn,
    }));

    const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Insumos Comprados");
    XLSX.writeFile(workbook, `Insumos_Mas_Comprados_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteInsumosMasCompradosPdf(this.state.dataReporte))
      .download(`Insumos_Mas_Comprados_${moment().locale("es").format("L")}.pdf`);
  }

  onFinishFailed(e) { ErrorItem(e); }

  render() {
    let columns = [
      { title: "Clave", dataIndex: "clave", key: "clave", buscar: "clave", width: "7%" },
      { title: "Código Barras", dataIndex: "codigoBarras", key: "codigoBarras", buscar: "codigoBarras", width: "9%" },
      { title: "Descripción", dataIndex: "descripcion", key: "descripcion", buscar: "descripcion", width: "18%", ellipsis: true },
      { title: "Familia", dataIndex: "familia", key: "familia", buscar: "familia", width: "8%" },
      { title: "Marca", dataIndex: "marca", key: "marca", buscar: "marca", width: "8%" },
      { title: "Tipo", dataIndex: "tipoInsumo", key: "tipoInsumo", buscar: "tipoInsumo", width: "8%" },
      { title: "Cantidad", dataIndex: "cantidad", key: "cantidad", sorter: (a, b) => a.cantidad - b.cantidad, align: "right", width: "7%" },
      { title: "Moneda", dataIndex: "moneda", key: "moneda", width: "6%", align: "center" },
      { title: "Costo Unit.", dataIndex: "precioUnitario", key: "precioUnitario", render: (value) => dineroDisabledMask(value), align: "right", width: "10%" },
      { title: "Costo Total", dataIndex: "costoTotal", key: "costoTotal", sorter: (a, b) => a.costoTotal - b.costoTotal, render: (value) => dineroDisabledMask(value), align: "right", width: "10%" },
      { title: "Costo Total (MXN)", dataIndex: "costoTotalMxn", key: "costoTotalMxn", sorter: (a, b) => a.costoTotalMxn - b.costoTotalMxn, render: (value) => <strong>{dineroDisabledMask(value)}</strong>, align: "right", width: "9%" },
    ];

    return (
      <>
        <Form ref={this.formRef} name="reporteInsumosComprados" onFinish={this.consultarReporteInsumosMasComprados.bind(this)} onFinishFailed={this.onFinishFailed} initialValues={{ periodo: [moment().subtract(1, "month"), moment()] }}>
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Insumos Más Comprados"
            style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && <ButtonItem blanco onClick={() => this.descargarExcel()} icon={<FileExcelOutlined />}>Descargar Excel</ButtonItem>}
                  {this.state.dataReporte && <ButtonItem blanco onClick={() => this.descargarPdf()} icon={<FilePdfOutlined />}>Descargar PDF</ButtonItem>}
                  <ButtonItem type="primary" htmlType="submit">Consultar</ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            {/* FILTROS */}
            <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5, borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Tabs style={{ margin: 0 }} tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}>
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle><RangePickerItem /></FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Proveedores">
                  <FormItem name="proveedores" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Proveedores">{this.state.objetoProveedores}</SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>Niguno</Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) return (<FormItem required name="proyectos" margin noStyle><SelectItem width="90%" placeholder="Proyectos" mode="multiple">{this.state.objetoProyectos}</SelectItem></FormItem>);
                          if (filtrarProyecto === 2) return (<FormItem required margin name="unidadDeNegocioId" noStyle><SelectItem width="90%" placeholder="Unidades de Negocio">{this.state.objetoUniadesDeNegocio}</SelectItem></FormItem>);
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Opciones">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem label="Estado de las Facturas" name="estadoFacturas" required initialValue={5} style={{ marginBottom: 0 }}>
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>Activas</Option>
                          <Option value={4}>Por Pagar</Option>
                          <Option value={3}>Pagadas</Option>
                          <Option value={2}>Vencidas</Option>
                          <Option value={1}>Canceladas</Option>
                          <Option value={0}>Todas</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            <div style={{ backgroundColor: "white", padding: 20, paddingBottom: 40, marginTop: 10, marginBottom: 10, height: 450, borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <h1 style={{ fontSize: 18, margin: 0, marginBottom: 10 }}>Top 10 Insumos Más Comprados</h1>
              <ResponsiveBar
                  data={this.state.dataGrafico}
                  keys={['Costo Total (MXN)']}
                  indexBy="insumo"
                  margin={{ right: 130, bottom: 50, left: 100 }}
                  padding={0.4}
                  layout="horizontal"
                  valueScale={{ type: 'linear' }}
                  indexScale={{ type: 'band', round: true }}
                  colors={["#f97316"]}
                  borderRadius={3}
                  borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{ tickSize: 5, tickPadding: 5, tickRotation: 0, legend: 'Monto (MXN $)', legendPosition: 'middle', legendOffset: 40, format: (v) => `$${v >= 1000 ? (v / 1000) + 'k' : v}` }}
                  axisLeft={{ tickSize: 5, tickPadding: 5, tickRotation: 0, legend: 'Clave Insumo', legendPosition: 'middle', legendOffset: -80 }}
                  enableLabel={false} 
                  legends={[{ dataFrom: 'keys', anchor: 'bottom-right', direction: 'column', justify: false, translateX: 120, translateY: 0, itemsSpacing: 2, itemWidth: 100, itemHeight: 20, itemDirection: 'left-to-right', itemOpacity: 0.85, symbolSize: 20, symbolShape: 'circle', effects: [ { on: 'hover', style: { itemOpacity: 1 } } ] }]}
                  tooltip={({ id, value, color, data }) => (
                      <div style={{ padding: '10px 14px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                          <strong style={{ fontSize: '13px' }}>{data.insumo} - {data.descCompleta}</strong><br />
                          <span style={{ color, fontWeight: '600', fontSize: '14px' }}>{id}: {dineroDisabledMask(value)}</span>
                      </div>
                  )}
                  role="application"
              />
            </div>

            {/* TOTALES */}
            <div style={{ backgroundColor: "white", padding: 15, marginBottom: 10, height: "75px", borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Row justify="center">
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total Piezas Compradas</p>
                  <h1 style={{ fontSize: 18 }}>{Number(this.state.piezasCompradas).toFixed(this.props.decimalesEmpresa || 2)}</h1>
                </Col>
                <Col span={2} style={{ textAlign: "center" }}><h1 style={{ fontSize: 24, color: '#ccc' }}>|</h1></Col>
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Costo Total del Periodo (MXN)</p>
                  <h1 style={{ fontSize: 18 }}>{dineroDisabledMask(this.state.costosTotales)}</h1>
                </Col>
              </Row>
            </div>

            <TableItem rowKey={(value) => value._id.toString() + Math.random()} columns={columns} dataSource={this.state.todasInsumos} size="small" pagination={false} />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken, empresaId: state.empresa.id, decimalesEmpresa: state.empresa.decimalesEmpresa });
export default connect(mapStateToProps)(ReporteInsumosMasComprados);